module.exports = __webpack_public_path__ + "static/media/Project3_Fig23.db6adf5c.png";